import { ref } from 'vue';

export function useTransitions() {
  const performanceLogging = ref(true); // Can be made configurable
  const transitionDuration = 300; // Milliseconds

  function onBeforeEnter(el) {
    if (performanceLogging.value) console.log(`[TRANSITION ${el.dataset.sectionName || 'UnknownSection'}] onBeforeEnter`);
    el.style.opacity = '0';
    el.style.height = '0px';
  }

  function onEnter(el, done) {
    if (performanceLogging.value) console.log(`[TRANSITION ${el.dataset.sectionName || 'UnknownSection'}] onEnter - target scrollHeight: ${el.scrollHeight}px`);
    el.offsetHeight; // Trigger reflow
    el.style.height = el.scrollHeight + 'px';
    el.style.opacity = '1';
    setTimeout(() => {
      if (performanceLogging.value) console.log(`[TRANSITION ${el.dataset.sectionName || 'UnknownSection'}] onEnter - done (timeout)`);
      done();
    }, transitionDuration);
  }

  function onAfterEnter(el) {
    if (performanceLogging.value) console.log(`[TRANSITION ${el.dataset.sectionName || 'UnknownSection'}] onAfterEnter`);
    el.style.height = '';
  }

  function onBeforeLeave(el) {
    if (performanceLogging.value) console.log(`[TRANSITION ${el.dataset.sectionName || 'UnknownSection'}] onBeforeLeave - current scrollHeight: ${el.scrollHeight}px`);
    el.style.height = el.scrollHeight + 'px';
    el.offsetHeight; // Trigger reflow
  }

  function onLeave(el, done) {
    if (performanceLogging.value) console.log(`[TRANSITION ${el.dataset.sectionName || 'UnknownSection'}] onLeave - animating to height 0px`);
    el.style.height = '0px';
    el.style.opacity = '0';
    setTimeout(() => {
      if (performanceLogging.value) console.log(`[TRANSITION ${el.dataset.sectionName || 'UnknownSection'}] onLeave - done (timeout)`);
      done();
    }, transitionDuration);
  }

  function onAfterLeave(el) {
    if (performanceLogging.value) console.log(`[TRANSITION ${el.dataset.sectionName || 'UnknownSection'}] onAfterLeave`);
    el.style.height = '';
    el.style.opacity = '';
  }

  // Add CSS styles for transitions
  function addTransitionStyles() {
    if (document.getElementById('step-transition-styles')) {
      return;
    }

    const style = document.createElement('style');
    style.id = 'step-transition-styles';
    
    // Use nonce if available
    if (window.cspNonce) {
      style.setAttribute('nonce', window.cspNonce);
    }
    
    style.textContent = `
      .step-transition-enter {
        opacity: 0;
        height: 0px;
        overflow: hidden;
        transition: all 0.3s ease-in-out;
      }
      
      .step-transition-enter-active {
        opacity: 1;
        overflow: hidden;
        transition: all 0.3s ease-in-out;
      }
      
      .step-transition-leave {
        overflow: hidden;
        transition: all 0.3s ease-in-out;
      }
      
      .step-transition-leave-active {
        height: 0px;
        opacity: 0;
        overflow: hidden;
        transition: all 0.3s ease-in-out;
      }
    `;
    
    document.head.appendChild(style);
  }

  const slideDown = (el) => {
    addTransitionStyles();
    el.classList.add('step-transition-enter');
    
    // Force reflow
    el.offsetHeight;
    
    // Set target height
    const targetHeight = el.scrollHeight;
    el.style.height = targetHeight + 'px';
    el.classList.add('step-transition-enter-active');
    el.classList.remove('step-transition-enter');
  };

  const slideDownComplete = (el) => {
    el.style.height = '';
    el.classList.remove('step-transition-enter-active');
  };

  const slideUp = (el) => {
    addTransitionStyles();
    el.style.height = el.scrollHeight + 'px';
    
    // Force reflow
    el.offsetHeight;
    
    el.classList.add('step-transition-leave');
    el.classList.add('step-transition-leave-active');
  };

  const slideUpComplete = (el) => {
    el.style.height = '';
    el.classList.remove('step-transition-leave');
    el.classList.remove('step-transition-leave-active');
  };

  return {
    onBeforeEnter,
    onEnter,
    onAfterEnter,
    onBeforeLeave,
    onLeave,
    onAfterLeave,
    slideDown,
    slideDownComplete,
    slideUp,
    slideUpComplete,
    // If performanceLogging needs to be controlled from outside, expose it or a method to toggle it
    // performanceLogging 
  };
} 